var VillaContent = {

	isMobile:false,

	init:function(){
		console.log("VILLA CONTENT INIT : " + $(".besoins--slider ul li").length);
		
		if($(".besoins--slider ul li").length <= 1){
			$(".besoins--slider .controls-container").css({display:"none"});
		}

		$(window).resize(function(){
			VillaContent.resize();
		});
		
		VillaContent.resize();
		
		setTimeout(function(){
			VillaContent.resize();
		}, 1000);

		$(".villa-menu-container .villa-menu-btn").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}

			VillaContent.changeContent($(this).index());

		});

		VillaContent.changeContent(0);


		$(".villa-content-wrapper .section-title").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}
			if($(this).parent().hasClass("open")){
				VillaContent.changeContent_mobile(-1);
			}else{
				VillaContent.changeContent_mobile($(this).parent().index());
			}
		});
	},
	
	resize:function(){
		if($(".villa-menu").css("display") == "none"){
			VillaContent.isMobile = true;
		}else{
			VillaContent.isMobile = false;
		}


		$(".villa-content-wrapper .content-mask").css({height:"auto"});

		if(VillaContent.isMobile){
			console.log("VILLA MOBILE MODE");
			$(".villa-content-wrapper .content-mask").each(function(){
				
				$(this).removeClass("animated");
				
				$(this).attr("data-height", $(this).height());

				if(!$(this).parent().hasClass("open")){
					$(this).css({height:0});
				}else{
					$(this).css({height:parseInt((this).attr("data-height"))})
				}
				
				
				$(this).addClass("animated");
			})
			
			
			if ($(".villa-types-container .types-list").hasClass('slick-initialized')) {
				$(".villa-types-container .types-list").slick('unslick');
			}
			
			$(".villa-types-container .types-list").slick({
				arrows:false, 
				dots:false,
				infinite: false,
				variableWidth:true,
				slidesToShow: 1,
				slidesToScroll: 1,
				mobileFirst: true,
				focusOnSelect: true,
				touchThreshold:500,
				centerMode:true, 
				asNavFor:$(".villa-types-container .villa-types-menu")
			});				
			
			if ($(".villa-types-container .villa-types-menu").hasClass('slick-initialized')) {
				$(".villa-types-container .villa-types-menu").slick('unslick');
			}
			
			$(".villa-types-container .villa-types-menu").slick({
				arrows:false, 
				dots:false,
				infinite: false,
				variableWidth:true,
				slidesToShow: 3,
				mobileFirst: true,
				focusOnSelect: true,
				touchThreshold:500,
				centerMode:false, 
				asNavFor:$(".villa-types-container .types-list")
			});				
			
		}else{
			
			console.log("VILLA DESKTOP MODE");
			if ($(".villa-types-container .types-list").hasClass('slick-initialized')) {
				$(".villa-types-container .types-list").slick('unslick');
			}
			if ($(".villa-types-container .villa-types-menu").hasClass('slick-initialized')) {
				$(".villa-types-container .villa-types-menu").slick('unslick');
			}
		}

	},
	changeContent:function(pID){
		$(".villa-menu-container .villa-menu-btn").each(function(){
			if($(this).index() == pID){
				$(this).addClass("selected");
			}else{
				$(this).removeClass("selected");
			}
		});

		$(".villa-content-wrapper section").each(function(){
			if($(this).index() == pID){
				$(this).removeClass("prev next").addClass("selected");
			}else{
				$(this).removeClass("selected next prev");

				if($(this).index() < pID){
					$(this).addClass("prev");
				}else{
					$(this).addClass("next");
				}
			}
		});

	},
	changeContent_mobile:function(pID){
		console.log("CHANGE MOBILE : " + $(".villa-content-wrapper .section-title").outerHeight());
		$(".villa-content-wrapper section").each(function(){
			if($(this).index() == pID){
				$(this).addClass("open");				
				$(this).find(".content-mask").css({height:parseInt($(this).find(".content-mask").attr("data-height"))});
			}else{
				$(this).removeClass("open");
				$(this).find(".content-mask").css({height:0});
			}
		});
		
		var _scrollDest = $(".villa-content-wrapper").offset().top + (pID * $(".villa-content-wrapper .section-title").outerHeight());
		
		$("html, body").stop().animate({scrollTop:_scrollDest}, 500);
		
		
	}
}